import { SaveCubesRequest } from "../api/barcodeSystem/inventory/cubes";

export class SaveCubesModel {
    manufacturerCode: string;
    modelNumber: string;
    cubes: number | null;
    visible: boolean = false;
    loading: boolean = true;
    saving: boolean = false;

    toSaveCubesRequest(): SaveCubesRequest {
        return { 
          manufacturerCode: this.manufacturerCode, 
          modelNumber: this.modelNumber,
          cubes: this.cubes
        };
    }
}
